import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';
import './NotFoundPage.scss';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <div className="error-state">
          <div className="error-code">404</div>
          <h1>Page Not Found</h1>
          <p>The page you're looking for doesn't exist.</p>
          <button className="back-button" onClick={() => navigate('/')}>
            <Home size={16} />
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
};
